import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import React, { forwardRef, ReactElement, Ref } from "react";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type TSlideUpDialog = {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  title: string;
} & React.ComponentProps<typeof Dialog>;

export default function SlideUpDialog({ open, handleClose, children, ...rest }: TSlideUpDialog) {
  return (
    <Dialog
      open={open}
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth={true}
      {...rest}
    >
      {rest.title && (
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            pb: 1,
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          {rest.title}
        </DialogTitle>
      )}

      {children}
    </Dialog>
  );
}
